import { ANALYSIS_LEVEL_TO_ATTRIBUTE_CODE, AnalysisLevel, ExtendedAttributeCode } from 'pages/trading/model';
import { FilterValue } from 'components/breadcrumb/breadcrumbModel';
import { formatDate } from 'utils/formatDate';
import { isValid } from 'date-fns';
import { calculateGranularity } from 'hooks/utils/calculateTimeGranularity';
import { DateRange } from 'components/filter/input/DateRangePicker/types';
import { AdditionalDateRange, DataRequest } from 'hooks/useDataRequest';
import { AttributeCode } from 'services/model/model.service';

export const tradingFiltersToDataRequest = (
  filters: Record<ExtendedAttributeCode, FilterValue[]>,
  adminView: boolean,
  comparisonRange?: DateRange,
  additionalDateRanges?: AdditionalDateRange[]
): DataRequest => {
  const dateRange = filters.dateRange && filters.dateRange.length > 0 ? (filters.dateRange[0] as DateRange) : null;
  const dateRangeGranularity = dateRange ? calculateGranularity(dateRange) : null;
  return {
    adminView,
    timeFilter:
      dateRange && dateRangeGranularity && dateRange.from && dateRange.to
        ? {
            fromDate: formatDate(dateRange.from),
            toDate: formatDate(dateRange.to),
            granularity: dateRangeGranularity,
          }
        : null,
    comparisonTimeFilter:
      comparisonRange?.from &&
      comparisonRange?.to &&
      isValid(comparisonRange.from) &&
      isValid(comparisonRange.to) &&
      dateRangeGranularity
        ? {
            fromDate: formatDate(comparisonRange.from),
            toDate: formatDate(comparisonRange.to),
            granularity: dateRangeGranularity,
          }
        : null,
    additionalDateRanges,
    creationTimeFilter: null,
    benchmarkingTimeFilter: null,
    benchmarkingComparisonTimeFilter: null,
    filters: {
      brands: (filters.prdBrand as string[]) ?? undefined,
      countries: (filters.chnCountry as string[]) ?? undefined,
      categories: (filters.prdCategory as string[]) ?? undefined,
      // genders,
      // ageGroups,
      // seasons,
      marketplaces: (filters.chnMarketplace as string[]) ?? undefined,
      // fulfillmentMethods,
      // dateBy,
      productNumbers: (filters.prdNumber as string[]) ?? undefined,
    },
  };
};

export const getAnalysisLevelFromAttributeCode = (attributeCode: AttributeCode): AnalysisLevel | undefined => {
  const levelEntry = Object.entries(ANALYSIS_LEVEL_TO_ATTRIBUTE_CODE).find(entry => {
    const values = entry[1];
    return values.length === 1 && values[0] === attributeCode;
  });
  return levelEntry ? (levelEntry[0] as AnalysisLevel) : undefined;
};
